"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeface = exports.typeScale = exports.theme = exports.globalSpacing = exports.globalSizing = exports.globalShadow = exports.globalGap = exports.globalFont = exports.globalColor = exports.globalBorder = void 0;
/**
 * Deprecated! Use tokens.ts going forward. Ref values for the system tokens. These are referenced from system tokens, but should not be used directly.
 * */

var color = {
  neutral: {
    50: '#ffffff',
    100: '#FCFBFD',
    200: '#E7E7F3',
    300: '#D3D3DF',
    400: '#A3A4B1',
    700: '#727483',
    800: '#393946',
    900: '#202028'
  },
  blue: {
    50: '#e5f4ff',
    100: '#ADDBFF',
    200: '#75C2FF',
    300: '#4696EC',
    500: '#008BFA',
    700: '#0768c0'
  },
  mauve: {
    200: '#D279E1'
  },
  purple: {
    50: '#F0E7FE',
    200: '#B27DF7',
    500: '#650ED8'
  },
  pine: {
    200: '#6CCBC1'
  },
  red: {
    100: '#FEB6B3',
    200: '#FD8B86',
    600: '#db0900'
  },
  green: {
    100: '#90E498',
    700: '#347E3C'
  },
  yellow: {
    200: '#FFF59E'
  },
  orange: {
    200: '#FFDE85',
    900: '#E57700'
  }
};
var unit = {
  0: '0',
  25: '1px',
  50: '2px',
  100: '4px',
  150: '6px',
  200: '8px',
  300: '12px',
  400: '16px',
  500: '20px',
  600: '24px',
  700: '28px',
  800: '32px',
  900: '36px',
  1000: '40px',
  1100: '44px',
  1200: '48px',
  1300: '52px',
  1600: '64px',
  2400: '96px',
  6400: '256px'
};

/**
 * System tokens. These are the tokens that should be used in the application.
 * */
var globalSizing = exports.globalSizing = {
  0: unit['0'],
  // 0
  25: unit['25'],
  // 1px
  50: unit['50'],
  // 2px
  100: unit['100'],
  // 4px
  150: unit['150'],
  // 6px
  200: unit['200'],
  // 8px
  300: unit['300'],
  // 12px
  400: unit['400'],
  // 16px
  600: unit['600'],
  // 24px
  800: unit['800'],
  // 32px
  1000: unit['1000'],
  // 40px
  1200: unit['1200'],
  // 48px
  1100: unit['1100'],
  // 44px
  1600: unit['1600'],
  // 64px
  2400: unit['2400'],
  // 96px
  6400: unit['6400'] // 256px
};

var globalSpacing = exports.globalSpacing = {
  0: unit['0'],
  // 0
  100: unit['100'],
  // 4px
  200: unit['200'],
  // 8px
  300: unit['300'],
  // 12px
  400: unit['400'],
  // 16px
  600: unit['600'],
  // 24px
  800: unit['800'] // 32px
};

var globalGap = exports.globalGap = {
  xs: globalSpacing['100'],
  s: globalSpacing['200'],
  m: globalSpacing['300'],
  l: globalSpacing['400'],
  xl: globalSpacing['600'],
  xxl: globalSpacing['800']
};
var globalColor = exports.globalColor = {
  brand: {
    primary: color.purple['500'],
    secondary: color.blue['700'],
    light: color.neutral['50']
  },
  text: {
    content: {
      primary: color.purple['500'],
      secondary: color.blue['700'],
      main: color.neutral['800'],
      auxiliary: color.neutral['700'],
      onDark: color.neutral['50']
    },
    disabled: {
      onLight: color.neutral['300'],
      onDisabled: color.neutral['700']
    },
    link: {
      visited: color.purple['500'],
      active: color.blue['700']
    },
    semantic: {
      error: color.red['600'],
      success: color.green['700']
    }
  },
  background: {
    primary: {
      1: color.purple['50'],
      2: color.purple['500']
    },
    secondary: {
      1: color.blue['50'],
      2: color.blue['300'],
      3: color.blue['700']
    },
    neutral: {
      1: color.neutral['50'],
      2: color.neutral['100'],
      3: color.neutral['700'],
      4: color.neutral['800']
    },
    disabled: {
      1: color.neutral['200']
    },
    semantic: {
      error: {
        1: color.red['100'],
        2: color.red['600']
      }
    }
  },
  border: {
    primary: color.purple['500'],
    enabled: color.neutral['700'],
    separator: color.neutral['300'],
    disabled: color.neutral['300'],
    active: color.blue['700'],
    error: color.red['600'],
    success: color.green['700'],
    warning: color.orange['900'],
    onDark: color.neutral['50']
  },
  iconFill: {
    primary: color.purple['500'],
    secondary: color.blue['700'],
    disabled: color.neutral['300'],
    onDark: color.neutral['50'],
    onLight: color.neutral['800'],
    onDisabled: color.neutral['700'],
    error: color.red['600'],
    success: color.green['700'],
    warning: color.orange['900']
  },
  id: {
    // identifier colors
    1: color.neutral['400'],
    2: color.red['100'],
    3: color.red['200'],
    4: color.mauve['200'],
    5: color.purple['200'],
    6: color.blue['100'],
    7: color.blue['200'],
    8: color.pine['200'],
    9: color.green['100'],
    10: color.yellow['200'],
    11: color.orange['200'],
    12: color.neutral['200']
  }
};
var globalBorder = exports.globalBorder = {
  radius: {
    1: globalSizing['50'],
    // 2px
    2: globalSizing['100'],
    // 4px
    3: globalSizing['200'],
    // 8px
    4: globalSizing['300'],
    // 12px
    5: globalSizing['400'],
    // 16px
    focusRing: globalSizing['150'] // 6px
  },

  width: {
    thin: globalSizing['25'],
    // 1px
    thick: globalSizing['50'] // 2px
  }
};

var globalShadow = exports.globalShadow = {
  1: "box-shadow: 0px 2px 4px 0 ".concat(color.neutral[900], "1f;"),
  2: "box-shadow: 0px 4px 16px 0 ".concat(color.neutral[900], "1f;"),
  modals: 'box-shadow: 0px 4px 16px 0 #0000001f;',
  focusRing: "box-shadow: 0px 0px 0px 2px ".concat(color.blue['500'], ";"),
  focusRingBrand: "box-shadow: 0px 0px 0px 2px ".concat(color.purple['500'], ";"),
  focusRingLight: "box-shadow: 0px 0px 0px 1px ".concat(color.blue['500'], ";"),
  tabs: "box-shadow: 0 2px 4px 0 #E0E0E0;"
};
var typeface = exports.typeface = {
  family: {
    display: 'Poppins',
    content: 'Inter'
  },
  weight: {
    display: {
      bold: '700'
    },
    content: {
      bold: '600',
      regular: '400'
    }
  },
  letterSpacing: {
    1: '0'
  },
  textCase: {
    capitalize: 'capitalize',
    uppercase: 'uppercase',
    lowercase: 'lowercase',
    none: 'none'
  },
  textDecoration: {
    none: 'none',
    underline: 'underline'
  }
};
var typeScale = exports.typeScale = {
  lineHeight: {
    1: '14px',
    2: '16px',
    3: '20px',
    4: '24px',
    5: '32px',
    6: '36px',
    7: '40px'
  },
  fontSize: {
    1: '10px',
    2: '12px',
    3: '14px',
    4: '16px',
    5: '20px',
    6: '24px',
    7: '28px',
    8: '32px'
  }
};
var globalFont = exports.globalFont = {
  heading: {
    1: "\n\t\t\t\tfont-family: ".concat(typeface.family.display, ";\n \n\t\t\t\tfont-weight: ").concat(typeface.weight.display.bold, ";\n \n\t\t\t\tfont-size: ").concat(typeScale.fontSize['8'], ";\n \n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(typeScale.lineHeight['7'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t\t\t\t"),
    2: "\n\t\t\t\tfont-family: ".concat(typeface.family.display, ";\n \n\t\t\t\tfont-weight: ").concat(typeface.weight.display.bold, ";\n \n\t\t\t\tfont-size: ").concat(typeScale.fontSize['7'], ";\n \n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(typeScale.lineHeight['6'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t\t\t\t"),
    3: "\n\t\t\t\tfont-family: ".concat(typeface.family.display, ";\n \n\t\t\t\tfont-weight: ").concat(typeface.weight.display.bold, ";\n \n\t\t\t\tfont-size: ").concat(typeScale.fontSize['6'], ";\n \n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(typeScale.lineHeight['5'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t\t\t\t"),
    4: "\n\t\t\t\tfont-family: ".concat(typeface.family.display, ";\n \n\t\t\t\tfont-weight: ").concat(typeface.weight.display.bold, ";\n \n\t\t\t\tfont-size: ").concat(typeScale.fontSize['5'], ";\n \n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(typeScale.lineHeight['4'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t\t\t\t")
  },
  subheading: {
    1: "\n\t\t\t\tfont-family: ".concat(typeface.family.content, ";\n \n\t\t\t\tfont-weight: ").concat(typeface.weight.content.bold, ";\n \n\t\t\t\tfont-size: ").concat(typeScale.fontSize['4'], ";\n \n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(typeScale.lineHeight['4'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t\t\t\t"),
    2: "\n\t\t\t\tfont-family: ".concat(typeface.family.content, ";\n \n\t\t\t\tfont-weight: ").concat(typeface.weight.content.bold, ";\n \n\t\t\t\tfont-size: ").concat(typeScale.fontSize['3'], ";\n \n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(typeScale.lineHeight['3'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t\t\t\t")
  },
  body: {
    1: "\n\t\t\t\tfont-family: ".concat(typeface.family.content, ";\n \n\t\t\t\tfont-weight: ").concat(typeface.weight.content.regular, ";\n \n\t\t\t\tfont-size: ").concat(typeScale.fontSize['4'], ";\n \n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(typeScale.lineHeight['4'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t\t\t\t"),
    2: "\n\t\t\t\tfont-family: ".concat(typeface.family.content, ";\n \n\t\t\t\tfont-weight: ").concat(typeface.weight.content.regular, ";\n \n\t\t\t\tfont-size: ").concat(typeScale.fontSize['3'], ";\n \n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(typeScale.lineHeight['3'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t\t\t\t")
  },
  detail: {
    1: "\n\t\t\t\tfont-family: ".concat(typeface.family.content, ";\n\n\t\t\t\tfont-weight: ").concat(typeface.weight.content.regular, ";\n\n\t\t\t\tfont-size: ").concat(typeScale.fontSize['2'], ";\n\n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n\n\t\t\t\tline-height: ").concat(typeScale.lineHeight['2'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t"),
    2: "\n\t\t\t\tfont-family: ".concat(typeface.family.content, ";\n\n\t\t\t\tfont-weight: ").concat(typeface.weight.content.regular, ";\n\n\t\t\t\tfont-size: ").concat(typeScale.fontSize['1'], ";\n\n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n\n\t\t\t\tline-height: ").concat(typeScale.lineHeight['1'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t")
  },
  label: {
    1: "\n\t\t\t\tfont-family: ".concat(typeface.family.content, ";\n\n\t\t\t\tfont-weight: ").concat(typeface.weight.content.bold, ";\n\n\t\t\t\tfont-size: ").concat(typeScale.fontSize['4'], ";\n\n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n\n\t\t\t\tline-height: ").concat(typeScale.lineHeight['4'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.none, ";\n\n\t")
  },
  links: {
    1: "\n\t\t\t\tfont-family: ".concat(typeface.family.content, ";\n \n\t\t\t\tfont-weight: ").concat(typeface.weight.content.regular, ";\n \n\t\t\t\tfont-size: ").concat(typeScale.fontSize['4'], ";\n \n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(typeScale.lineHeight['4'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.underline, ";\n\n\t\t\t\t"),
    2: "\n\t\t\t\tfont-family: ".concat(typeface.family.content, ";\n \n\t\t\t\tfont-weight: ").concat(typeface.weight.content.regular, ";\n \n\t\t\t\tfont-size: ").concat(typeScale.fontSize['3'], ";\n \n\t\t\t\tletter-spacing: ").concat(typeface.letterSpacing['1'], ";\n \n\t\t\t\tline-height: ").concat(typeScale.lineHeight['3'], ";\n\n\t\t\t\ttext-transform: ").concat(typeface.textCase.none, ";\n\n\t\t\t\ttext-decoration: ").concat(typeface.textDecoration.underline, ";\n\n\t\t\t\t")
  }
};
var theme = exports.theme = {
  colors: globalColor,
  fonts: globalFont,
  border: globalBorder,
  spacing: globalSpacing,
  shadow: globalShadow
};